//拍卖、社区接口集合
import config from '@/utils/config'
const wApi = {


	//	拍卖部分接口-----------------------------------------------------------------------------------------------------------------------------------------------------------------start
  // 首页上
  homepageHead: function() {
    return fly.get( config.wapApi + "app/homepage/head");
  },
  // 首页下
    homepageFooter: function() {
      return fly.get( config.wapApi + "app/homepage/footer");
    },
  // 首页接口
	getData: function() {
		return fly.post( config.wapApi + "app/homepage/getData");
	},
	//首页历史拍品
	history: function(postData) {
		return fly.post( config.wapApi +  "app/auction/historyAuction",postData);
	},
	/*所有历史拍品(需要传入的参数)
	入参：
	  page---页码,rows---单页数量,auctionSessionType---（0.默认拍场 1.每日一拍 2.推荐收藏区 3.饮用精选拍区 4.价格封顶拍区）
	*/
	historylist: function(postData) {
		return fly.post( config.wapApi + "app/auction/getMoreHisAuction", postData);
	},
	/*拍场列表
	入参：
	     page---页码，rows---单页数量，state---拍场状态（数组），如：state:[2,3]，就是获取预展中和正在拍卖中的拍场
	*/
	sessionlist: function(postData) {
		return fly.post(config.wapApi+  "app/auction/sessionInfoPage", postData);
	},
	/*根据拍场类型 查询拍品品品品品品品品品
	入参：
	     page---页码，rows---单页数量， auctionSessionType（0.默认拍场 1.每日一拍 2.推荐收藏区 3.饮用精选拍区 4.价格封顶拍区）
	*/
 	getAreaAuction: function(postData) {
		return fly.post( config.wapApi + "app/homepage/getAreaAuction", postData);
	},
	/*根据拍场类型 查询拍场场场场场场场场场
	入参：
	     page---页码，rows---单页数量， auctionSessionType（0.默认拍场 1.每日一拍 2.推荐收藏区 3.饮用精选拍区 4.价格封顶拍区）
	*/
 	getEverydayAuction: function(postData) {
		return fly.post( config.wapApi + "app/homepage/getEverydayAuction", postData);
	},
	/*获取饮用精选更多
	入参：
	     page---页码，rows---单页数量，  type:2推荐 3精选
	*/
 	getChoiceAndCollection: function(postData) {
		return fly.post( config.wapApi + "app/homepage/getChoiceAndCollection", postData);
	},
  /*根据产地分类
   入参：
         page---页码，rows---单页数量    chanDi --- 产地id
  */
  findAuctionGoods: function(postData) {
    return fly.post( config.wapApi + "app/classify/findAuctionGoods", postData);
  },
  /*搜索拍拍品
   入参：
         page---页码，rows---单页数量   type---- *   search --- 搜索关键字
  */
  getLikeAuction: function(postData) {
    return fly.post( config.wapApi + "app/auction/getLikeAuction", postData);
  },
	/*拍场详情
  入参：
       auctionSessionSeq---拍场seq，customerSeq---用户seq，page---页码，rows---单页数量，term待确认，目前传0
  */
	sessionDetail: function(postData) {
	  if(!postData.auctionSessionSeq){
	    return false;
    }
		return fly.post( config.wapApi + "app/auction/auctionShow", postData);
	},
  /*交保证金列表
入参：
     auctionSessionSeq---拍场seq，current---页码，size---单页数量，brandId---品牌  searchType---查询方式 1 价格正序 2 价格倒叙
*/
  payBondList: function(postData) {
    return fly.post( config.wapApi + "app/bondRecord/payBondList", postData);
  },
  /*拍场品牌列表
	入参：
	     auctionSessionSeq---拍场seq
	*/
  getAuctionBrand: function(auctionSessionSeq) {
    return fly.post( config.wapApi + "app/auction/auctionBrand/"+ auctionSessionSeq);
  },
	/*拍品详情
	入参：
	     auctionGoodsSeq---拍品seq, customerSeq---用户seq
	*/
	saleDetail: function(postData) {
		return fly.post( config.wapApi + "app/auction/auctionInfo", postData);
	},
  // 获取顾问信息 拍品详情页面
  getConsultantInfoApi: function(postData) {
  	return fly.get( config.wapApi + "app/auction/getCounselor", postData);
  },
  // 获取所有拍品列表 不分页用于拍品详情页面
  getAuctionGoodsListApi: function(postData) {
  	return fly.get( config.wapApi + "app/auction/listBySessionId", postData);
  },
	//单桶拍卖列表
	BarreAuctionList:function(postData){
		return fly.post( config.wapApi + 'app/auction/querySingleBarreAuctionList',postData)
	},
	//单桶拍卖详情
	BarreAuctionDetail:function(id){
		return fly.get( config.wapApi + 'app/auction/querySingleBarreAuctionDetail/' + id)
	},
	//判断拍卖是单桶还是普通单瓶，返回的类型
	AuctionType:function(id){
		return fly.get( config.wapApi + 'app/auction/verifyAutionSessionTypeByGoodsSeq/' + id)
	},
  /*设置提醒
	入参：
	     customerSeq
        用户seq
        auctionSessionSeq
        拍场seq
        auctionGoodsSeq
        拍品seq
	*/
  remind: function (postData){
    return fly.post( config.wapApi + 'app/auction/remind', postData);
  },
  /*取消提醒
   入参：
        customerSeq
       用户seq
       auctionSessionSeq
       拍场seq
       auctionGoodsSeq
       拍品seq
   */
  cancelRemind: function (postData){
    return fly.post( config.wapApi + 'app/auction/cancelRemind', postData);
  },
    //opr/liveAuctionSession
  /*todo:运营平台的接口   用来获取直播中的拍品列表  （只用于直播）
  入参：
    auctionSessionSeq ， page， rows
  */
  liveAuctionSession: function (page,rows,auctionSessionSeq){
    return fly.get(`${config.oprApi}opr/liveAuctionSession?page=${page}&rows=${rows}&auctionSessionSeq=${auctionSessionSeq}`);
  },
	/* 获取出价记录
   入参：
   customerSeq---用户seq
   auctionGoodsSeq---拍品seq
   */
	auctionRecordDetail: function(postData) {
		return fly.post( config.wapApi + 'app/person/auctionRecordDetail', postData);
	},
	/* 获取竞拍记录(我的竞拍，历史竞拍)
   入参：
   customerSeq---用户seq
   condition---排序（猜的，不知道）
   searchTrim---搜索关键字
   page---页数
   rows---数量
   states    我的竞拍传  "2,3"   历史竞拍传  "4,5"
   */
	auctionRecord: function(postData) {
		return fly.post( config.wapApi + 'app/person/auctionRecord', postData);
	},
  /* 获取我的竞拍
 入参：
 orderField---排序字段（price - 不使用排序时不传）
 current---页数
 size---数量
 isAsc---	是否升序（true-升序  false-降序）
 auctionState---拍品状态（热拍中-0，预展中-1，已结束-2）
 associatedState---关联状态（热拍中：0-全部，1-领先，2-出局，3-未出价；已结束：0-全部，1-得拍，2-出局，3-流拍）
 */
  customerAuctionRecord: function(postData) {
    return fly.post( config.wapApi + 'app/person/customerAuctionRecord', postData);
  },
	/*判断有没有交过保证金
	入参：
	   auctionGoodsSeq:
	   auctionSessionSeq :
	   customerSeq:
	*/
	bondPayedOrNot: function(postData) {
		return fly.post( config.wapApi + "app/auction/bondPayedOrNot", postData);
	},
  /*交保证金的时候判断拍品是否已经结束了  app/auction/validate/3679
  入参：
     auctionGoodsSeq:
  */
  ifEndAuction: function(auctionGoodsSeq) {
    return fly.get( config.wapApi + "app/auction/validate/" + auctionGoodsSeq);
  },
	/*支付保证金页面初始化数据
	入参：
	   auctionGoodsSeq:
	   auctionSessionSeq :
	   customerSeq:
	*/
	getBond: function(postData) {
		return fly.post( config.wapApi + "app/auction/toPayBond", postData);
	},
	/*获取收藏列表
	 入参：
	    customerSeq:
	    page
	    rows
	 */
	queryFavorite: function(postData) {
		return fly.post( config.wapApi + "app/person/queryFavorite", postData);
	},
	/*获取足迹列表
	 入参：
	    customerSeq:
	    page
	    rows
	 */
	track: function(postData) {
		return fly.post( config.wapApi + "app/person/track", postData);
	},
	/*判断有没有收藏
	 入参：
	    auctionGoodsSeq:
	    auctionSessionSeq :
	    customerSeq:
	 */
	isNotFavorite: function(postData) {
		return fly.post( config.wapApi + "app/person/isNotFavorite", postData);
	},
	/*收藏拍品
	入参：
	   auctionGoodsSeq:
	   customerSeq :
	   status:   当前收藏的状态  1在收藏，0未收藏
	*/
	favorite: function(postData) {
		return fly.post( config.wapApi + "app/person/favorite", postData);
	},
	/*拍卖出价
	入参：
	   auctionGoodsSeq    拍品序号
	   auctionSessionSeq  拍场序号
	   customerSeq      用户序号
	   price           出价价格
	   highestPrice    最高价，如果是自由出价没有设置心理价就传0
	   "offerType":"0",   默认传0，暂时不知道为什么
	   signNo   ---  叫价记录里的编号
	*/
	raisePrice: function(postData) {
		return fly.post( config.wapApi + 'app/auction/raisePrice', postData);
	},
  //预展中委托出价
  setProxyPrice: function(postData) {
    return fly.post( config.wapApi + 'app/auction/setProxyPrice', postData);
  },
  //保证金/加价 幅度规则
  //type   类型 1加价幅度规则 2保证金规则
  //current   当前页     可以不传（不需要分页）
  //size   	每页条数     可以不传（不需要分页）
  rangeRule: function(postData) {
    return fly.post( config.wapApi + 'app/rangeRule/queryList', postData);
  },
	/*获取当前拍品的最高叫价和最新拍卖信息(叫价前要请求一次)
	入参：
	   auctionGoodsSeq    拍品序号
	   auctionSessionSeq  拍场序号
	   customerSeq      用户序号
	*/
	getHighestPrice: function(postData) {
		return fly.post( config.wapApi + 'app/person/getHighestPrice', postData);
	},
	/*洽谈
	入参：
	   auctionGoodsSeq  拍品序号
	   customerSeq      用户序号
	   price            求购，出售的价格
	   number           求购，出售的数量
	   type             类型，   0---求购   1---出售
	*/
	insertAuctionGoodsNegotiate: function(postData) {
		return fly.post( config.wapApi + 'app/auction/insertAuctionGoodsNegotiate', postData);
	},
	/*
	获取订单数据
	入参：
	  customerSeq
	  page
	  rows
	  states         订单状态：  0---待付款，1_2 ---待收货，3---已完成
	 */
	findSnapshot: function(postData) {
		return fly.post( config.wapApi + 'app/person/findSnapshot', postData);
	},
	/*
	获取订单详情
	入参：
	   orderSeq---订单序号
	 */
	orderInfo: function(postData) {
		return fly.post( config.wapApi + 'app/person/orderInfo', postData);
	},
	/*
	获取违约单数据
	入参：
	  customerSeq
	  page
	  rows
	 */
	getTreaty: function(postData) {
		return fly.post( config.wapApi + 'app/person/getTreaty', postData);
	},
	/*
	  订单申诉接口
	  入参：
	    auctionSessionSeq
	    customerSeq
   */
	insertOrderExplain: function(postData) {
		return fly.post( config.wapApi + 'app/person/insertOrderExplain', postData);
	},
	/*
	  去付款前的检查接口（暂时不理解，参照小程序写的）
	  入参：
    auctionSessionStr    字符串的选中去支付的拍场seq
   */
	paymentCheck: function(postData) {
		return fly.post( config.wapApi + 'app/paymentCheck', postData);
	},
	/*
	 获取结算中心基础数据
	 入参：
	   customerSeq
	   deliveryAddrSeq     不知道是什么，默认穿空
	   snapshotSeqArray    不理解，参照小程序写的，数组来的，但是只存放了一个需要支付的拍场seq
	  */
	paySnapshot: function(postData) {
		return fly.post( config.wapApi + 'app/person/paySnapshot', postData);
	},
	/* 	确认收货
	   入参：
		订单seq
   */
	validateOrder: function(seq) {
		return fly.post( config.wapApi + `app/person/validateOrder/${seq}`);
	},
	//	拍卖部分接口-----------------------------------------------------------------------------------------------------------------------------------------------------------------end

//  社区部分接口----------------------------------------------------------------------------------------------------------------------------------------------------------------start
	/* 	搜索全部帖子列表
	   入参：
		page	int	-	当前页
		rows	int	-	每页显示大小
		title	String	-	搜索内容
   */
	querySearchAll: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/querySearchAll', postData);
	},
	/* 	交流帖列表
	   入参：
		page
		rows
		customerSeq   用户seq
		orderBy       排序 1 默认排序 2 标签排序 3 按回复时间排序 4按回复数量排序
		sort		  1 正序 2 倒序
		title	String	-	搜索内容
   */
	queryInterflowList: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/assess/queryInterflowList', postData);
	},
	/* 	酒评帖列表
	   入参：
		page
		rows
		customerSeq   用户seq
		orderBy       排序 1 默认排序 2 标签排序 3 按回复时间排序 4按回复数量排序
		sort		  1 正序 2 倒序
		title	String	-	搜索内容
   */
	wrlist: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/assess/list', postData);
	},
	/* 	分享帖列表
	   入参：
		page
		rows
		customerSeq   用户seq
		orderBy       排序 1 默认排序 2 标签排序 3 按回复时间排序 4按回复数量排序
		sort		  1 正序 2 倒序
		newOrOld      最新分享1历史分享2
		state         审核状态0待审核1通过 2拒绝
		isTop         暂时不清楚
		title	String	-	搜索内容
   */
	sharelist: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/list', postData);
	},
	//寄存/待发货列表
	//参数状态 state 1-待发货  5-寄存
	myBbsPost: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/queryMyBbsPost',postData)
	},
	/* 	帖子详情(酒评帖，交流帖)
	   入参：
		page
		rows
	 	pid    帖子id
	 	uid    发帖人id
	 	type   类型1：分享帖，2：酒评帖，3交流帖
   */
	postAssessDetail: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/assess/postDetail', postData);
	},
	/* 	帖子详情(分享帖)
	   入参：
		page
		rows
	 	pid    帖子id
	 	uid    发帖人id
	 	type   类型1：分享帖，2：酒评帖，3交流帖
   */
	postDetail: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/postDetail', postData);
	},
	/* 	分享空瓶（专用瓶）详情
	   入参：
		bid:"1"
   */
	queryBbsBottleById: function() {
		return fly.post( config.wapApi + 'app/bbs/bottle/queryBbsBottleById', {bid:"1"});
	},
	/* 	获取帖子赞赏列表（打赏榜单）
	   入参：
	 	pid    帖子id
	 	type   类型1：分享帖，2：酒评帖，3交流帖
   */
	queryPostReward: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/assess/queryPostReward', postData);
	},
	/* 	帖子点赞
	   入参：
		pid
		uid    登录用户
		type   类型1：分享帖，2：酒评帖，3交流帖
   */
	insertPostPraise: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/assess/insertPostPraise', postData);
	},

	/* 	关注用户
	   入参：
		followUid    发帖子的用户
		uid	      登录用户     （这里严重的坑，为什么有些uid是登录用户，有些是发帖子的用户）
   */
	follow: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/follow', postData);
	},

	/* 	取消关注用户
	   入参：
		followUid    发帖子的用户
		uid	      登录用户（这里严重的坑，为什么有些uid是登录用户，有些是发帖子的用户）
   */
	cancelFollow: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/cancelFollow', postData);
	},
		/* 	发帖子的用户
	   入参：
		customerSeq   登录用户
		uid    查询的用户（发帖子的用户）（todo:这里严重的坑，为什么有些uid是登录用户，有些是发帖子的用户）
   */
	queryCustomer: function(postData) {
	  if(!postData.uid) return;
		return fly.post( config.wapApi + 'app/bbs/post/queryCustomer', postData);
	},

	/* 分享吧订单
	   入参：
		page
		rows
	 	uid    用户id
	 	state   状态 0待付款1待发货2待收货 3已收货 4取消订单
   */
	queryOrderByStatus: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/queryOrderByStatus', postData);
	},
	/* 分享空瓶订单
	   入参：
		page
		rows
	 	uid    用户id
	 	state   状态 0待付款1待发货2待收货 3已收货 4取消订单
   */
	queryBottleOrder: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/bottle/queryBottleOrder', postData);
	},
	/* 分享吧订单确认收货
	   入参：
		 uid:用户,
		 orderNo:订单号
   */
	receOrderShare: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/receOrder', postData);
	},
	/* 专用瓶订单确认收货
	   入参：
		 uid:用户,
		 orderNo:订单号
   */
	receOrder: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/bottle/receOrder', postData);
	},
	/* 删除分享订单
	   入参：
		 oid  --- 订单id
   */
	deleteOrder: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/post/deleteOrder', postData);
	},
	/* 删除专用空瓶订单
	   入参：
		 boid  --- 订单id
   */
	deleteBottleOrder: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/bottle/deleteBottleOrder', postData);
	},
	/* 取消专用空瓶订单
	   入参：
		 orderNo  --- 订单号
   */
	orderBottleCancel: function(postData) {
		return fly.post( config.wapApi + 'app/bbs/bottle/orderCancel', postData);
	},



//直播接口-----------------------------start

//进入直播间

//进入直播间   入参：   auctionSessionSeq
goLiveState: function(auctionSessionSeq) {
  return fly.get( config.wapApi + 'app/auction/live/' + auctionSessionSeq);
},

//开始当前拍品拍卖    入参：   auctionSessionSeq   auctionGoodsSeq
startAuctionGoods: function(postData) {
  return fly.post( config.oprApi + 'opr/liveAuctionSession/startAuctionGoods', postData);
},

//结束当前拍品拍卖    入参：   auctionSessionSeq   auctionGoodsSeq
endAuctionGoods: function(postData) {
  return fly.post( config.oprApi + 'opr/liveAuctionSession/endAuctionGoods', postData);
},
//刷新拍品   入参：   auctionSessionSeq   auctionGoodsSeq
  refreshAuctionGoods: function(postData) {
  return fly.get( config.oprApi + 'opr/liveAuctionSession/refreshAuctionGoods', postData);
},
//开始倒计时
beginCountDown: function(postData) {
  return fly.post( config.oprApi + 'opr/liveAuctionSession/beginCountDown', postData);
},
//停止倒计时
  stopCountDown: function(postData) {
    return fly.post( config.oprApi + 'opr/liveAuctionSession/stopCountDown', postData);
  },

//  获取云品鉴直播状态，直播信息
goLivePost: function(id) {
  return fly.get( config.wapApi + 'app/bbs/post/liveStatus/' + id);
},

//云品鉴直播
cLive:function(id){
return fly.get( config.wapApi + "/app/bbs/post/live/" + id);
},

//云品鉴列表
cloudReviewList: function(postData){
	return fly.get( config.wapApi + '/app/bbs/post/liveList',postData);
},
//云品鉴历史列表，精彩回顾
//请求参数：current:1   size:20
liveHistory: function(postData){
	return fly.post( config.wapApi + '/app/bbs/post/liveHistory', postData);
},
//云品鉴官方评论
//频道 liveId   评论message   title
postOfficialComments: function(postData){
	return fly.post( config.wapApi + '/app/bbs/post/postOfficialComments',postData);
},
//云品鉴客户评论列表
//入参  liveId	 page
liveComments:function(postData){
	//return fly.get( config.wapApi + '/app/bbs/post/liveComments/',postData);
	return fly.get( config.wapApi + '/app/bbs/post/liveComments/' + postData, '');
},

//直播接口-----------------------------end

//单桶接口--------------------------------------------------------------------------------------------------------










//单桶定制步骤详情
customizationSteps: function(postData){
	return fly.get( config.wapApi + '/api/customization/queryCustomizationStep',postData);
},



//单桶接口--------------------------------------------------------------------------------------------------------


	//	公共模块接口(包括支付,地址,物流,发票等)---------------------------------------------------------------------------------------------------------------------------------------------start

	/*
	  中威钱包支付(保证金支付)
	  入参：
	    auctionSessionSeq
	    customerSeq
	    auctionGoodsSeq
	    payType   //类型是：支付拍场保证金 101; 支付拍品保证金 102; 充值 103; 订单支付 104;  分享瓶支付105;
	    totalFee    保证金金额
	    bondType    2---竞拍保证金
	    中威钱包支付(拍卖订单支付)
	    入参：

	     */
	walletPay: function(postData) {
		return fly.post( config.wapApi + 'app/walletPay', postData);
	},
  /*
  微信支付(拍卖)

  */
  salewxPay: function(postData) {
    return fly.post(config.wapApi + 'weixin/h5Pay', postData);
  },
	/*
	支付宝支付
	入参：
	 除了和中威钱包一样的参数以为另外再添加一个路径参数
	 fromUrl   ---    支付成功后的跳转路径
	*/
	payment: function(postData) {
		return fly.post(config.wapApi + 'alipay/payment', postData);
		// return fly.post('http://wap.cwhisky.com/alipay/payment',postData);
	},
	/*银联支付
	   入参：
	    同支付宝支付一样
	    fromUrl   ---    支付成功后的跳转路径
   */
  consume: function(postData) {
    return fly.post(config.wapApi +  'unionpay/consume', postData);
  },
  /*线下支付
	   入参：

   */
  offLinePay: function(postData) {
    return fly.post(config.wapApi +  'app/offLinePay', postData);
  },
	/* 获取账户余额
	入参：
	customerSeq---用户seq
	*/
	getBalance: function(customerSeq) {
		return fly.post( config.wapApi + 'app/person/homepage/' + customerSeq);
	},

	/* 发票列表数据(移动端只要普通发票就行了)
	  入参：
	  customerSeq---用户seq
	  */
	cusInvoice: function() {
		return fly.get( config.commonApi + 'invoice/myDefault');
	},
	/* 新增（编辑）发票
	入参：
	invoiceSeq   发票id（有传则是修改，没传就是新增）
	identificationNumber	string	100	纳税人识别号 （*）
	invoiceHeadContent	string	100	发票抬头内容 （*）
	invoiceHeadType	int	1	发票抬头类型(1单位 2个人) （*）
	invoiceType	int	1	发票类型(1电子 2纸质 ) （*）
	*/
	updateInvoice: function(postData) {
		return fly.post( config.commonApi + 'invoice/save', postData);
	},

  //增票资质列表
  invoicePage: function(postData){
    return fly.post( config.commonApi + 'invoice/page', postData);
  },
  //增票详情
  detailInvoice: function(id) {
    return fly.get( config.commonApi + 'invoice/detail/'+ id);
  },
  //删除增票
  deleteInvoice: function(id) {
    return fly.get( config.commonApi + 'invoice/delete/'+ id);
  },
  /*  公司工商信息查询
  入参：
  "company":"中威网"
  */
  queryCompanyInfo: function(postData) {
    return fly.post( config.commonApi + 'invoice/queryCompanyInfo', postData);
  },
 	//查询物流
 	//  返回数据 state = 3 代表已签收
	queryExpress: function(postData) {
		return fly.post( config.commonApi + 'common/core/queryExpress?express='+postData.express+'&expressNumber='+postData.expressNumber);
	},


	/* 	获取收货地址列表
	   入参：
 		current---当前页
 		size---条数
	   */
	deliveryAddress: function(postData = {current:1,size:20}) {
		return fly.post( config.commonApi + 'deliveryAddress/list',postData);
	},
  /* 	设置默认收货地址
	   入参：
        Id   ---   地址id
	   */
  setAddress: function(id) {
    return fly.get( config.commonApi + 'deliveryAddress/set/'+ id);
  },
	/*获取默认收货地址*/
	addressDefault: function() {
		return fly.get( config.commonApi + 'deliveryAddress/default');
	},
	/* 	新增收货地址
	   入参：
		consignee	string	收货人
		phone	string	手机号码
		addr	string	详细地址
		flag	int	是否默认（0：非 1：默认）
		province	int	后台存入的省市区地址
		pCode	string	省编号
		cCode	string	市编号
		dCode	string	区编号
	   */
	addAddress: function(postData) {
		return fly.post( config.commonApi + 'deliveryAddress/new',postData);
	},
	/* 	编辑收货地址
	   入参：
		consignee	string	收货人
		phone	string	手机号码
		addr	string	详细地址
		flag	int	是否默认（0：非 1：默认）
		province	int	后台存入的省市区地址
		pCode	string	省编号
		cCode	string	市编号
		dCode	string	区编号
	   */
	editAddress: function(postData) {
		return fly.post( config.commonApi + 'deliveryAddress/update',postData);
	},
	//删除收货地址   id---地址id
	addressRemove: function(id) {
		return fly.get( config.commonApi + 'deliveryAddress/remove/' + id);
	},
  //版本号
  banben: function(id) {
    return fly.get( config.yunApi + 'data.json');
  },
  //判断访谈状态   1---未开始   2---进行中   3---已结束（回放）
  getInterviewState: function () {
    return fly.get(config.wapApi + 'app/homepage/interview')
  },
	//	公共模块接口(包括支付,地址,物流等)---------------------------------------------------------------------------------------------------------------------------------------------end

	//骑士团会员首页
	knightTeam: function(){
		return fly.get( config.wapApi + "app/vip/knightTeam/list");
	},
	//骑士团主页
	knightTeamHome:function (postData) {
		return fly.post( config.wapApi + 'app/vip/knightTeam/homePage/',postData)
	},
	//积分首页
	PointsHome:function(postData) {
		return fly.post( config.wapApi +'app/person/queryCustomerIntegralRecordList',postData)
	},
	//开通会员获取金额回调接口
	openVip:function(postData) {
		return fly.post( config.wapApi +'/app/vip/knightTeam/openVip',postData)
	},
	//取消委托价
	revocationHighestPrice:function(postData) {
		return fly.post( config.wapApi +'/app/auction/revocationHighestPrice',postData)
	},
	//社区用户推荐
	getBbsPostRecommend:function(postData) {
		return fly.post( config.wapApi +'/app/bbs/post/getBbsPostRecommend',postData)
	},
	//查询邮箱
	queryCustomerMail:function(){
		return fly.get( config.wapApi +'app/bbs/post/queryCustomerMail')
	},
	//订单导出邮箱
	excelOrder:function(postData) {
		return fly.post( config.wapApi +'app/bbs/post/excelOrder',postData)
	},
	//订单提交
	submitOrder:function(postData) {
		return fly.post( config.wapApi +'/app/bbs/post/submitOrder',postData)
	},
	//订单发货
	orderDeliver:function(postData){
		return fly.post( config.wapApi +'/app/bbs/post/orderDeliver',postData)
	},
	//获取物流公司信息
	metaDataType:function(){
		return fly.get( config.wapApi +'/app/bbs/post/metaDataType/express')
	},
	saveFeed:function(postData){
		return fly.get( config.wapApi +'/app/person/saveFeed',postData)
	}

}

export default wApi



// WEBPACK FOOTER //
// ./src/utils/api/wApi.js